import React from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faCheck, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import pizza_portion_left_image from '../../../assets/images/icon_pizza_half_left.png';
import pizza_portion_right_image from '../../../assets/images/icon_pizza_half_right.png';
import pizza_portion_whole_image from '../../../assets/images/icon_pizza_whole.png';

class MenuItemChoiceSelection extends React.Component {

    constructor(props) {
        super(props);
    }

    renderToppingIcon() {
        if (this.props.cartToppings && this.props.topping) {

            let theIcon = null;

            this.props.cartToppings.forEach((theCartTopping) => {
                if (theCartTopping.id == this.props.topping.id) {

                    if (theCartTopping.amount == "extra" || (!this.props.isCustomPizza && !theCartTopping.isdefault && theCartTopping.amount == "include")) {
                        theIcon = (
                            <FontAwesomeIcon 
                                icon={faPlus} 
                                className="left-topping-icon"
                            />
                        );
                    }
                    else if ((theCartTopping.isdefault && theCartTopping.amount == "include") || (this.props.isCustomPizza && theCartTopping.amount == "include")) {
                        theIcon = (
                            <FontAwesomeIcon 
                                icon={faCheck} 
                                className="left-topping-icon"
                            />
                        );
                    }
                }
            });

            if (theIcon) {
                return theIcon;
            }
        }
    }

    renderRightImage() {
        if (this.props.cartToppings && this.props.topping) {
            let pizzaImage = pizza_portion_whole_image;
            let includePortionImage = false;

            this.props.cartToppings.forEach((theCartTopping) => {
                if (theCartTopping.id == this.props.topping.id) {
                    includePortionImage = true;

                    if (!theCartTopping.isdefault && theCartTopping.amount == "none") {
                        includePortionImage = false;
                    }
                    else {
                        if (theCartTopping.portion == "H1") {
                            pizzaImage = pizza_portion_left_image;
                        }
                        else if (theCartTopping.portion == "H2") {
                            pizzaImage = pizza_portion_right_image;
                        }
                    }
                    
                }
            });

            if (includePortionImage) {
                return (
                    <a
                        onClick={this.props.onPortionPress}
                    >
                        <img
                            src={pizzaImage}
                            className="right-pizza-image-icon"
                        />
                    </a>
                );
            }
        }
        else if (!this.props.isMultiple) {
            return (
                <FontAwesomeIcon 
                    icon={faChevronRight} 
                    className="right-arrow-icon"
                />
            );
        }
    }

    printSelectionText() {
        if (this.props.selectionText && this.props.selectionText != "") {
            return (
                <p 
                    className="cart-choice-selection-text"
                >
                    {this.props.selectionText}
                </p>
            );
        }
    }
    
    render() {
        return (
            <a 
                className="menu-item-choice-selection-window"
                onClick={this.props.onChoicePress}
            >
                <div className="choice-container">
                    <div className={(this.props.isToppingItem) ? "content-window content-window-row" : "content-window"}>
                        {this.renderToppingIcon()}
                        <p 
                            className={(this.props.choice || (this.props.selectionText && this.props.selectionText != "")) ? 'choice-name-text' : 'choice-text'}
                        >
                            {this.props.children}
                        </p>
                        {(this.props.choice && this.props.selection) && (
                            <p 
                                className="cart-choice-selection-text"
                            >
                                {this.props.selection.item_name}{(this.props.selection.item_price > 0) && " - "+this.props.selection.item_price}
                            </p>
                        )}
                        {this.printSelectionText()}
                    </div>
                    {this.renderRightImage()}
                </div>
            </a>
        );
    }
};

const mapStateToProps = (state) => {

    return {
        quantity: state.cartItem.quantity
    };
};

export default connect(mapStateToProps)(MenuItemChoiceSelection);